import React, { useState, useEffect } from 'react';
import '../Css/Login.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import { checkToken } from '../context/CommonContex';

function Login() {
  const [input, setInput] = useState({
    username: '',
    password: '',
  });
  
  const [checkingToken, setCheckingToken] = useState(true);
  const [isValidToken, setIsValidToken] = useState(false);
  const navigate = useNavigate();

  const auth = useAuth();

  useEffect(() => {
    const validateToken = async () => {
      try {
        const isValid = await checkToken(); // Your token check API call
        if (isValid) {
          setIsValidToken(true);
          navigate('/dashboard'); // ✅ navigate instead of return <Navigate />
        } else {
          setIsValidToken(false);
        }
      } catch (error) {
        setIsValidToken(false);
      } finally {
        setCheckingToken(false);
      }
    };

    validateToken();
  }, [navigate]);
  const handleSubmitEvent = (e) => {
    e.preventDefault();
    if (input.username !== '' && input.password !== '') {
      auth.loginAction(input);
      return;
    }
    alert('Please provide a valid input');
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInput({
      ...input,
      [name]: value,
    });
  };

  // // ✅ Show loading while checking token
  // if (checkingToken) {
  //   return <div>Checking authentication...</div>;
  // }

  // ✅ Redirect if token is valid
 

  return (
    <div className="wrapper fadeInDown d-flex align-items-center justify-content-center">
      <div id="formContent" className="login-form">
        <form onSubmit={handleSubmitEvent} style={{ padding: '45px' }} className="login-form">
          <input
            type="text"
            id="user-email"
            name="username"
            className="fadeIn second"
            onChange={handleInput}
            placeholder="User Name"
            required
          />
          <input
            type="password"
            id="password"
            name="password"
            className="fadeIn third"
            onChange={handleInput}
            placeholder="Password"
            required
          />
          <input
            type="submit"
            className="fadeIn fourth btn-dark"
            value="Log In"
          />
        </form>
        <div id="formFooter">
          <a className="underlineHover" href="#">
            Forgot Password?
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;
